export default __webpack_public_path__ + "images/dab72fe7b92e8083ef65bd9c0aa33eb3.svg";